import {createSelector} from 'reselect'

export const irrs = createSelector(
    state => state.irrs.irrs,
    irrs => irrs
);


// WEBPACK FOOTER //
// ./src/modules/irr/irr.selectors.js